
import { MxAiModule } from "../MxAiModule";
import { Wall } from "./drawWall";
import { Bock } from "./InsertBock"
export function init() {
  MxAiModule.regist(Wall)
  MxAiModule.regist(Bock)
}
